export default {
    alerts_today: false,
    calendar_events: [],
    last_start_date: null,
    last_end_date: null,
    reschedule_requests: []

};
